import React from "react";
import Questions_Table from "./table";
import {Container} from "react-bootstrap";
import nmss from './nmss.json'
const dummyQuestions = [
    { name: 'risk1', title: 'System outage likelihood' },
    { name: 'risk2', title: 'Data loss potential' },
    { name: 'risk3', title: 'Security breach impact' },
];
const dummyData = {
    // pre-fill only the second question
    risk2: { severity: 3, frequency: 2, product: 6 },
};
class NMSS extends React.Component{
    constructor(props) {
        super();
        this.state = {}
    }
    handleTableChange = async (state) =>{
       await this.setState((prevState) => ({
            ...prevState,
            ...state

        }))
        this.props.handler('nmss',this.state)
    }
    async componentDidMount() {
        if (this.props.data){
          await  this.setState(this.props.data);
        }
    }
    // componentDidUpdate(prevProps, prevState) {
    //     // this.props.handler('nmss',this.props.data);
    //
    // }

    render() {
        return (
            <Container>
                <Questions_Table
                    questions={nmss}
                    handler={this.handleTableChange}
                    data={this.props.data ? this.props.data : null}
                    disabled={this.props.disabled}
                    score={true}           // true to enable scoring accumulation
                    // fieldName="riskAssessment"
                />
            </Container>
        )
    }
}

export default NMSS;

NMSS.defaultProps = {
    handler:null
}